import Interaction from 'ol/interaction/Interaction';
import { planModuleDblClick } from '@/features/dashboard-map/interactions/moduleDblClickPolicy';

export function createModuleDblClickZoomGuard({
  resolveModule,
  isModuleListOpen,
  onModuleDblClick
}) {
  return new Interaction({
    handleEvent(mapBrowserEvent) {
      if (mapBrowserEvent.type !== 'dblclick') {
        return true;
      }
      const resolved = resolveModule(mapBrowserEvent);
      const plan = planModuleDblClick({
        resolvedModule: resolved,
        moduleListOpen:
          typeof isModuleListOpen === 'function' ? !!isModuleListOpen() : !!isModuleListOpen
      });
      if (plan.openPencil) {
        onModuleDblClick(resolved);
      }
      return !plan.stopZoom;
    }
  });
}
